import { IonButton, IonContent, IonGrid, IonPage } from "@ionic/react";
import React from "react";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import {
  dummyPatient,
  loggedInUserState,
  newAllDropDownState,
  PatientState,
} from "../../data/atoms";
import { ActionType, PatientSetting } from "../../models/Enums";
import { format } from "date-fns";
import { getFormatedMobileNumber } from "../../utils/sharedFunction";

interface Props {
  setShowModal1: Function;
  actionType: ActionType;
  reset: Function;
  isEdit: boolean;
}

const ExitModal: React.FC<Props> = ({
  setShowModal1,
  actionType,
  reset,
  isEdit,
}) => {
  let history = useHistory();

  const [patient, setpatientDetails] = useRecoilState(PatientState);
  let [userToEdit, setuserToEditt] = useRecoilState(loggedInUserState);
  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);
  // const resetList = useResetRecoilState(newAllDropDownState);
  // console.log("actionType modal", actionType)
  const getDatafromId = (id: number) => {
    if (id == 6) {
      return;
    }
    let LookupId: string = PatientSetting[id] as unknown as string;
    return LookupId;
  };

  const exitPatientProfileSetup = () => {
    setpatientDetails(dummyPatient);
    actionType === ActionType.ExitPatientSetup
      ? reset({
          firstname: patient!?.firstName,
          lastname: patient!?.lastName,
          nickname: patient!?.nickName,
          dob: patient!?.dob,
          email: patient!?.email,
          zipcode: patient!?.zip,
          mrn: patient!?.mrn,
          phone: getFormatedMobileNumber(patient!?.mobilePhone!),
          setting: getDatafromId(patient!?.patientSetting),
          referral: patient!?.referralId!,
          physician: patient!?.physicianId,
          department: patient!?.departmentId,
          testPatient: false,
          dobFormatted:
            patient?.dob == undefined || patient?.isNew == true
              ? ""
              : format(new Date(patient?.dob), "MM/dd/yyyy"),
        })
      : reset();
    setShowModal1(false);

    if (
      actionType === ActionType.ExitPatientSetup ||
      actionType === ActionType.CreateNewPatient
    ) {
      history.replace("/home");
    } else if (
      actionType === ActionType.NewUser ||
      actionType === ActionType.UserDoesNotExist
    ) {
      history.replace("/login");
    } else if (
      actionType === ActionType.ForgotPassword ||
      actionType === ActionType.ExitForgotPassword ||
      actionType === ActionType.ExitExpiredPassword
    ) {
      if (actionType === ActionType.ExitExpiredPassword) {
        localStorage.setItem("isOtpFlow", "false");
      }
      history.replace("/login");
    }
  };
  const exitUserProfile = () => {
    setShowModal1(false);
    history.replace("/home");
  };
  return (
    <div className="overall-center-modal">
      <div className="generic-modal-main-wrap">
        <div className="icon-sec text-center">
          {/* Exit SVG */}
          {(actionType === ActionType.ExitPatientSetup ||
            actionType === ActionType.CreateNewPatient ||
            actionType === ActionType.NewUser ||
            actionType == ActionType.EditUserProfile) && (
            <svg
              width="103"
              height="103"
              viewBox="0 0 103 103"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47.4783 30.4158C49.6994 28.1947 53.3006 28.1947 55.5217 30.4158L72.5842 47.4783C73.6508 48.5449 74.25 49.9916 74.25 51.5C74.25 53.0084 73.6508 54.4551 72.5842 55.5217L55.5217 72.5842C53.3006 74.8053 49.6994 74.8053 47.4783 72.5842C45.2572 70.3631 45.2572 66.7619 47.4783 64.5408L54.8317 57.1875H6C2.85888 57.1875 0.3125 54.6411 0.3125 51.5C0.3125 48.3589 2.85888 45.8125 6 45.8125L54.8317 45.8125L47.4783 38.4592C45.2572 36.2381 45.2572 32.6369 47.4783 30.4158Z"
                fill="#802392"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.3125 11.6875C0.3125 5.40526 5.40526 0.3125 11.6875 0.3125H91.3125C97.5947 0.3125 102.688 5.40526 102.688 11.6875V91.3125C102.688 97.5947 97.5947 102.688 91.3125 102.688H11.6875C5.40526 102.688 0.3125 97.5947 0.3125 91.3125V79.9375C0.3125 76.7964 2.85888 74.25 6 74.25C9.14112 74.25 11.6875 76.7964 11.6875 79.9375V91.3125H91.3125V11.6875H11.6875V23.0625C11.6875 26.2036 9.14112 28.75 6 28.75C2.85888 28.75 0.3125 26.2036 0.3125 23.0625V11.6875Z"
                fill="#802392"
              />
            </svg>
          )}
          {/* Exit SVG */}

          {/* Start of UserDoesNotExist SVG */}
          {actionType == ActionType.UserDoesNotExist && (
            <svg
              width="163"
              height="130"
              viewBox="0 0 163 130"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                opacity="0.4"
                d="M113.748 32.4993C113.748 47.5302 103.566 60.1745 89.7032 63.8814L48.749 31.7884C49.1298 14.1677 63.526 0 81.2483 0C99.199 0 113.748 14.5485 113.748 32.4993ZM67.106 77.262L133.374 129.464C132.511 129.819 131.571 129.997 130.581 129.997H31.9154C27.7514 129.997 24.3745 126.62 24.3745 122.456C24.3745 98.3103 43.2901 78.5569 67.106 77.262Z"
                fill="black"
              />
              <path
                d="M1.29632 2.33731C3.37831 -0.303253 7.21221 -0.785665 9.85277 1.29632L160.162 119.106C162.803 121.188 163.285 125.022 161.203 127.663C159.121 130.303 155.287 130.786 152.647 128.704L2.33731 10.8938C-0.303253 8.81178 -0.785665 4.97788 1.29632 2.33731Z"
                fill="#802392"
              />
            </svg>
          )}
          {/* End of UserDoesNotExist SVG */}
        </div>

        <div className="generic-modal-text">
          {(actionType === ActionType.ExitPatientSetup ||
            actionType === ActionType.CreateNewPatient) && (
            <>
              <h1>Are you sure you want to exit patient setup?</h1>
              <p>Your information will not be saved.</p>
            </>
          )}
          {actionType === ActionType.NewUser && (
            <>
              <h1>Are you sure you want to exit account setup?</h1>
              <p>Your information will not be saved.</p>
            </>
          )}
          {(actionType === ActionType.ForgotPassword ||
            actionType === ActionType.ExitForgotPassword ||
            actionType === ActionType.ExitExpiredPassword) && (
            <>
              <h1>
                {actionType === ActionType.ExitExpiredPassword
                  ? "Reset "
                  : "Forgot "}
                Password
              </h1>
              <p>Are you sure you want to exit?</p>
              <p>Any information you entered will be cleared.</p>
            </>
          )}
          {actionType === ActionType.UserDoesNotExist && (
            <>
              <h1>Error</h1>
              <p>No user on file with this email or password.</p>
            </>
          )}
          {actionType === ActionType.EditUserProfile && (
            <>
              <h1>Leave page without saving?</h1>
              <p>Any changes you have made will be discarded.</p>
            </>
          )}
        </div>

        <div className="generic-modal-btn-wrap two-btns">
          <ul>
            {(actionType === ActionType.ExitPatientSetup ||
              actionType === ActionType.CreateNewPatient ||
              actionType === ActionType.NewUser ||
              actionType === ActionType.ForgotPassword ||
              actionType === ActionType.ExitForgotPassword ||
              actionType === ActionType.ExitExpiredPassword ||
              actionType === ActionType.EditUserProfile) && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    setShowModal1(false);
                  }}
                >
                  {actionType !== ActionType.ForgotPassword ? "Back" : "Cancel"}
                </IonButton>
              </li>
            )}

            {(actionType === ActionType.ExitPatientSetup ||
              actionType === ActionType.CreateNewPatient ||
              actionType === ActionType.NewUser ||
              actionType === ActionType.ForgotPassword ||
              actionType === ActionType.ExitForgotPassword ||
              actionType === ActionType.ExitExpiredPassword) && (
              <li>
                <IonButton
                  className="generic-btn"
                  placeholder={undefined}
                  onClick={exitPatientProfileSetup}
                >
                  Exit
                </IonButton>
              </li>
            )}

            {actionType === ActionType.UserDoesNotExist && (
              <li>
                <IonButton
                  className="generic-btn generic-btn-outline"
                  placeholder={undefined}
                  onClick={() => {
                    setShowModal1(false);
                    history.push("/email", {
                      actionType: ActionType.NewUser,
                    });
                  }}
                >
                  Setup Account
                </IonButton>
              </li>
            )}

            {actionType === ActionType.UserDoesNotExist && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={exitPatientProfileSetup}
                  placeholder={undefined}
                >
                  Retry
                </IonButton>
              </li>
            )}

            {actionType === ActionType.EditUserProfile && (
              <li>
                <IonButton
                  className="generic-btn"
                  onClick={exitUserProfile}
                  placeholder={undefined}
                >
                  Leave
                </IonButton>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ExitModal;
